import { render, staticRenderFns } from "./ApprovedFinanceReport.vue?vue&type=template&id=0a0630b8"
import script from "./ApprovedFinanceReport.vue?vue&type=script&lang=js"
export * from "./ApprovedFinanceReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a0630b8')) {
      api.createRecord('0a0630b8', component.options)
    } else {
      api.reload('0a0630b8', component.options)
    }
    module.hot.accept("./ApprovedFinanceReport.vue?vue&type=template&id=0a0630b8", function () {
      api.rerender('0a0630b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/reports/ApprovedFinanceReport.vue"
export default component.exports